import { helper } from "lib/helper";
import contact_usModel from "models/contact_us.model";
import { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import {
  Card,
  Row,
  Container,
  CardHeader,
  Col,
  CardBody,
  CardTitle,
  NavItem,
  TabContent,
  NavLink,
  Nav,
  CardText,
  Button,
  Table,
  FormGroup,
  FormText,
  Form,
  Input,
  Label,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,
  TabPane,
  ListGroup,
  ListGroupItem,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Dropdown,
  CardFooter,
  Lable,
  UncontrolledTooltip,
} from "reactstrap";
import AddModal from "views/components/AddModal";
// core components
import TablePagination from "views/components/TablePagination";
import SubAdmins from "models/subadmins.modal"
import { Link } from "react-router-dom";
import EhcDiscover from "../../../models/Ehcdescover.model";
import tutorsModal from "models/tutors.modal";
import enquiriesModal from "models/enquiries.modal";
import Select from "react-select";
import EhcCordination from "models/Ehccordination.modal";
import Parentmodel from "models/parents.modal";
import StudentList from "models/studentlist.modal";
import EhcReport from "models/Echreport.modal";
import EhcTest from "models/Echtest.modal";
import { error } from "ajv/dist/vocabularies/applicator/dependencies";
import RaiseComplains from "models/raisecomplain.modal";
import  EhcShowtReport from "models/Ehcswotreport.modal";
import EchConsultation from "models/Echconsultation.modal";
import StateModel from "models/states.model";

import CityModel from "models/city.model";


const ViewEHC = () => {
  const [modal1, setModal1] = useState(false);
  const [discoverdata, setDiscoverdata] = useState();
  const [cordinationdata, setCordinationdata] = useState();
  const [parentdata, setParentData] = useState();
  const [ studentlistData,setStudentlistData] = useState();
  const [selectOption, setselectOption] = useState();
  const [supervisorlistdata, setsupervisorlistdata] = useState();
  const [EchRepotlist, setEchRepotlist] =useState();
  const [state, setState] = useState();
  const [city, setCity] = useState();
  const [selectedState, setSelectedState]= useState();

  const parms = useParams();
 console.log("parmsssss",parms)
// Get State

  // get list of state
  const GetState = async () => {
    StateModel.listState()
      .then((responce) => {
        console.log("stateee", responce.results);
        setState(responce?.results);
        
      })
      .catch((error) => {
        console.log("error", error);
      });
  };

  const handleStateChange = (e) =>{
    const value = e.target.value
    
    const find= state.find((item)=>item.name == value)
    console.log("----gg",find)
    setSelectedState(find);
  
   
  }
  const GetCity = async()=>{

    
    CityModel.getcitybyid(selectedState?.id)
    .then((response)=>{
      setCity(response)
    })
    .catch((error)=>{
      console.log("error",error)
    })
  }
  useEffect(()=>{
    GetCity();
  },[selectedState])
  
  const handleSubmiteditParentDetails = (event) => {
    event.preventDefault();
    const form = new FormData(event.target);
   
    enquiriesModal
      .editParentDeatils(form)
      .then((response) => {
        
        ParentDetail();
        toggleModal4();
        helper.sweetalert.toast(response.data.message, "success");
      })
      .catch((error) => {
        helper.sweetalert.toast(error?.response?.data?.name[0], "error");
      });
  };
 
 //

 
// * ADD Consultation form

const Addconsultation = async(event)=>{
  event.preventDefault();
  const form =  new FormData(event.target)
  const date = form.get("date")
  const [yy, mm, dd]= date.split("-");
  const formate = `${dd}-${mm}-${yy}`
  form.set("date",formate)
  EchConsultation.Add(form)
  .then((responce)=>{
     helper.sweetalert.toast(responce.data?.message);
  }
)
.catch((error)=>{
  helper.sweetalert.toast(error.response?.data?.message, "warning")
})
}
 // * Subject_1
   
   const [subject_1, setsubject_1]= useState({
    subject_name: '',
    question: '',
    marks: '',
    total_marks: ''
  })
  const handleChangesubject_1 = (e) => {
    const { name, value } = e.target;
    setsubject_1(prevState => ({
      ...prevState,
      [name]: value
    }));
  };
  // * Subject_2
   
   const [subject_2, setsubject_2]= useState({
    subject_name: '',
    question: '',
    marks: '',
    total_marks: ''
  })
  
  const handleChangesubject_2 = (e) => {
    const { name, value } = e.target;
    setsubject_2(prevState => ({
      ...prevState,
      [name]: value
    }));
  };
  // * Subject_3
   
  const [subject_3, setsubject_3]= useState({
    subject_name: '',
    question: '',
    marks: '',
    total_marks: ''
  })
  
  const handleChangesubject_3 = (e) => {
    const { name, value } = e.target;
    setsubject_3(prevState => ({
      ...prevState,
      [name]: value
    }));
  };
// * Subject_4
   
const [subject_4, setsubject_4]= useState({
  subject_name: '',
  question: '',
  marks: '',
  total_marks: ''
})

const handleChangesubject_4 = (e) => {
  const { name, value } = e.target;
  setsubject_4(prevState => ({
    ...prevState,
    [name]: value
  }));
};
// submit swot report



const SwortForm = async(event)=>{
  event.preventDefault();
  const form = new FormData(event.target)
  form.append("subject_1[subject_name]", subject_1.subject_name);
  form.append("subject_1[question]", subject_1.question);
  form.append("subject_1[marks]", subject_1.marks);
  form.append("subject_1[total_marks]", subject_1.total_marks);
  form.append("subject_2[subject_name]", subject_2.subject_name);
  form.append("subject_2[question]", subject_2.question);
  form.append("subject_2[marks]", subject_2.marks);
  form.append("subject_2[total_marks]", subject_2.total_marks);
  form.append("subject_3[subject_name]", subject_3.subject_name);
  form.append("subject_3[question]", subject_3.question);
  form.append("subject_3[marks]", subject_3.marks);
  form.append("subject_3[total_marks]", subject_3.total_marks);
  form.append("subject_4[subject_name]", subject_4.subject_name);
  form.append("subject_4[question]", subject_4.question);
  form.append("subject_4[marks]", subject_4.marks);
  form.append("subject_4[total_marks]", subject_4.total_marks);
      
  EhcShowtReport.Add(form)
  .then((responce)=>{
    helper.sweetalert.toast(responce.data?.message);
  })
  .catch((error)=>{
    console.log("error",error?.response?.data?.
      message)
      helper.sweetalert.toast(error.response?.data?.message, "warning");})
}
  // Raise complain
  const RaiseComplain = async(event)=>{
    event.preventDefault();
    const form = new FormData(event.target)
    form.append("parent_id",parms?.mid)
 RaiseComplains.Raise(form)
 .then((responce)=>{
  helper.sweetalert.toast(responce.data?.message);
 })
 .catch((error)=>{
  helper.sweetalert.toast(error.response?.data?.message, "warning");})
  
 
  }
  // Get supewiser
  const Supervisorlist = async()=>{
    SubAdmins.Getlist()
    .then((responce)=>{
      setsupervisorlistdata(responce?.data)
      console.log("gud weel",responce)
    })
    .catch((error)=>{
      console.log("error",error)
    })
  }
  // A General overview
    // * concept_of_understanding
  const [concept_of_understanding, setconcept_of_understanding]= useState({
    marks: '',
    total: '',
    remark: ''
  })
  const handleChangeconceptUnderstanding = (e) => {
    const { name, value } = e.target;
    setconcept_of_understanding(prevState => ({
      ...prevState,
      [name]: value
    }));
  };
// * tuition_copy_maintenance
const [tuition_copy_maintenance, settuition_copy_maintenance]= useState({
  marks: '',
  total: '',
  remark: ''
})
const handleChangetutionManintance = (e) => {
  const { name, value } = e.target;
  settuition_copy_maintenance(prevState => ({
    ...prevState,
    [name]: value
  }));
};
//* syllabus_coverage
const [syllabus_coverage, setsyllabus_coverage]= useState({
  marks: '',
  total: '',
  remark: ''
})
const handleChangesyllabus_coverage = (e) => {
  const { name, value } = e.target;
  setsyllabus_coverage(prevState => ({
    ...prevState,
    [name]: value
  }));
};
//B. Answersheet Analysis
  //* concept_clarity
  const [concept_clarity, setconcept_clarity]= useState({
    marks: '',
    total: '',
    remark: ''
  })
  const handleChangeconcept_clarity = (e) => {
    const { name, value } = e.target;
    setconcept_clarity(prevState => ({
      ...prevState,
      [name]: value
    }));
  };
  //* time_management
  const [time_management, settime_management]= useState({
    marks: '',
    total: '',
    remark: ''
  })
  const handleChangetime_management = (e) => {
    const { name, value } = e.target;
    settime_management(prevState => ({
      ...prevState,
      [name]: value
    }));
  };
    //* presentation_skills
    const [presentation_skills, setpresentation_skills]= useState({
      marks: '',
      total: '',
      remark: ''
    })
    const handleChangepresentation_skills = (e) => {
      const { name, value } = e.target;
      setpresentation_skills(prevState => ({
        ...prevState,
        [name]: value
      }));
    };
    //* question_understanding
    const [question_understanding, setquestion_understanding]= useState({
      marks: '',
      total: '',
      remark: ''
    })
    const handleChangequestion_understanding = (e) => {
      const { name, value } = e.target;
      setquestion_understanding(prevState => ({
        ...prevState,
        [name]: value
      }));
    };

    // * submit report form
    const ReportSubmit = async(event)=>{
      console.log("check",concept_clarity)
      event.preventDefault();
      const form = new FormData(event.target)
      form.append("class_id",parms?.id);
      form.append("concept_of_understanding[marks]", concept_of_understanding.marks);
      form.append("concept_of_understanding[total]", concept_of_understanding.total);
      form.append("concept_of_understanding[remark]", concept_of_understanding.remark);
      form.append("tuition_copy_maintenance[marks]", tuition_copy_maintenance.marks);
      form.append("tuition_copy_maintenance[total]", tuition_copy_maintenance.total);
      form.append("tuition_copy_maintenance[remark]", tuition_copy_maintenance.remark);
      form.append("syllabus_coverage[marks]", syllabus_coverage.marks);
      form.append("syllabus_coverage[total]", syllabus_coverage.total);
      form.append("syllabus_coverage[remark]", syllabus_coverage.remark);
      form.append("concept_clarity[marks]", concept_clarity.marks);
      form.append("concept_clarity[total]", concept_clarity.total);
      form.append("concept_clarity[remark]", concept_clarity.remark);
      form.append("time_management[marks]", time_management.marks);
      form.append("time_management[total]", time_management.total);
      form.append("time_management[remark]", time_management.remark);
      form.append("presentation_skills[marks]", presentation_skills.marks)
      form.append("presentation_skills[total]", presentation_skills.total)
      form.append("presentation_skills[remark]", presentation_skills.remark)
      form.append("question_understanding[marks]", question_understanding.marks)
      form.append("question_understanding[total]", question_understanding.total)
      form.append("question_understanding[remark]", question_understanding.remark)
      EhcReport.Add(form)
      .then((responce)=>{
        helper.sweetalert.toast(responce.data?.message);
      })
      .catch((error)=>{
        helper.sweetalert.toast(error.response?.data?.message, "warning");
      })
    }
  
  const [shortTermFields, setShortTermFields] = useState([{ id: 1, value: "" }]);
  const [longTermFields, setLongTermFields] = useState([{ id: 1, value: "" }]);

  const handleAddField = (setFields, fields) => {
    const newField = { id: fields.length + 1, value: "" };
    setFields([...fields, newField]);
  };

  const handleRemoveField = (setFields, fields, id) => {
    setFields(fields.filter(field => field.id !== id));
  };
  const [strengthFields, setStrengthFields] = useState([{ id: 1, value: "" }]);
  const [weaknessFields, setWeaknessFields] = useState([{ id: 1, value: "" }]);
  const [threatsFields, setThreatsFields] = useState([{ id: 1, value: "" }]);
  const [opportunitiesFields, setOpportunitiesFields] = useState([{ id: 1, value: "" }]);

  const handleAddField1 = (setFields, fields) => {
    const newField = { id: fields.length + 1, value: "" };
    setFields([...fields, newField]);
  };

  const handleRemoveField1 = (setFields, fields, id) => {
    setFields(fields.filter(field => field.id !== id));
  };


  useEffect(()=>{
    
    Getoldechlist();
  },[])
  //submit EchTest
  const EchTest = async(event)=>{
    event.preventDefault();

    const form = new FormData(event.target)
    form.append("class_id",parms?.id)
  
   
    EhcTest.AddechTest(form)
    .then((responce)=>{
      console.log("responce",responce)
      helper.sweetalert.toast(responce.data?.message);
    })
    .catch((error)=>{
      helper.sweetalert.toast(error.response?.data?.message, "warning");
    })
  }

// GET ECH REPORT BY CLASS ID ONCHANGE
const Getoldechlist = async()=>{
  EhcReport.ListByClassId(parms.id)
  .then((responce)=>{
    
    setEchRepotlist(responce?.data)
    
    console.log("old ",responce?.data)
  })
  .catch((error)=>{
    helper.sweetalert.toast(error.response?.data?.message, "warning");
  })
}


const studentlistbyId = async()=>{
  StudentList.StudentListbyParentId(parms?.mid)
  .then((responce)=>{
    
    setStudentlistData(responce?.data?.data)
  })
  .catch((error)=>{
    console.log("error",error)
  })
}
 
  // parent Detail
  const ParentDetail = async()=>{
    Parentmodel.listbyParentid(parms?.uid)
    .then((responce)=>{
    
      setParentData(responce?.data?.data)
    })
    .catch((error)=>{
      console.log("error",error)
    })
  }
  console.log("-----parent deatail",parentdata)
  //Add Cordination
  const AddCordination = async(event)=>{
    
    event.preventDefault();
  const form = new FormData(event.target);
 
  const data = form.get("date")
const[ yy, mm, dd] = data.split("-")

  const formatedate = `${dd}-${mm}-${yy}`
  form.set("date",formatedate);
  form.append("parent_id",parms?.uid)
  if(parms?.uid){
    EhcCordination.Add(form)
    .then((responce)=>{
    
      toggleModal2();
      helper.sweetalert.toast(responce.data?.message);
      GEtcordinationList();
    })
    .catch((error)=>{
      console.log("error",error)
    })}
  }
  // Get EHC Coordination list
   const GEtcordinationList = async()=>{
    EhcCordination.List(parms?.uid)
    .then((responce)=>{
      setCordinationdata(responce?.data)
    })
    .catch((error)=>{})

   }
  
// Add discovery list
const Adddiscovery= async(event)=>{
  event.preventDefault();
  const form = new FormData(event.target);
 
  const data = form.get("date")
const[ yy, mm, dd] = data.split("-")

  const formatedate = `${dd}-${mm}-${yy}`
  form.set("date",formatedate);
  form.append("class_id",parms?.id)

  EhcDiscover.Add(form)
  .then((responce)=>{
    toggleModal1();
    helper.sweetalert.toast(responce.data?.message);
    DiscoverList();
  })
  .catch((error)=>{
    console.log("error",error)
  })
}
// Get Descover list
  const DiscoverList = async () => {
    EhcDiscover.List(parms?.id)
      .then((responce) => {
        setDiscoverdata(responce?.data);
      })
      .catch((error) => {
        console.log("like", error);
      });
  };
  useEffect(() => {
    DiscoverList();
    GEtcordinationList();
    ParentDetail();
 studentlistbyId();
 GetState();
 Supervisorlist();
 Getoldechlist();

  }, []);
  const toggleModal = () => {
    setModal1(!modal1);
  };
  const [modal2, setModal2] = useState(false);

  const toggleModal1 = () => {
    setModal2(!modal2);
  };
  const [modal3, setModal3] = useState(false);

  const toggleModal2 = () => {
    setModal3(!modal3);
  };
  const [modal4, setModal4] = useState(false);

  const toggleModal4 = () => {
    setModal4(!modal4);
  };

  const [modal5, setModal5] = useState(false);

  const toggleModal5 = () => {
    setModal5(!modal5);
  };

  const [isLoading, setIsLoading] = useState(true);
  const [dataList, setDataList] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const parameters = {};
  for (let [key, value] of searchParams) {
    parameters[key] = value;
  }



  console.log(dataList, "dataListdataList");

  
  const AssignTutors = () => {
    helper.sweetalert.confirm(
      "Are you sure you want to Assign tutors ",
      "info",
      true
    );
  };
  const [selectedClassType, setSelectedClassType] = useState("");

  const handleChangeClassType = (event) => {
    // Get the selected option
    const selectedOption = event.target.options[event.target.selectedIndex];
    // Update the state variables with the ID and name
    setSelectedClassType(selectedOption.value);
  };
  // select mode function
  const [selecttMode, setSelectMode] = useState("");
  const handleChangeMode = (event) => {
    const { value } = event.target;
    setSelectMode(value);
  };
  const item = [];

  const [isChecked, setIsChecked] = useState(false);

  const handleCheckboxChange = () => {
    setIsChecked(!isChecked);
  };

  return (
    <>
      <Container className="pt-7">
       

        <Row>
          <div className="col mt-4 ">
            <Card className="w-100 border" style={{ borderRadius: ".5rem" }}>
              {/*<CardHeader
                className="p-2 "
                style={{ color: "black", fontWeight: "bold", backgroundColor: "#f5f5f5" }}
              >
                <Row className="d-flex justify-content-between"><Col>Basice Details{" "}</Col>
                <Col md={3}><Input type="select" onChange={(e)=>{setselectOption(e.target.value)}}>
                <option value="">select</option>
                <option value="Old EHC">Old EHC</option>
                
                </Input></Col>
                </Row>
              </CardHeader>*/}
              <div className="shadow-sm" style={{ backgroundColor: "#f5f5f5" }}>
                <CardBody className="p-0 pl-4">
                  <Row>
                    <Col size="3">
                      {/* <div className="top-card-div"> */}
                      <div
                        style={{
                          lineHeight: "13px",
                          paddingTop: "15px",
                        }}
                      >
                        <p>
                          {" "}
                          <span style={{ color: "#999896" }}>
                            Parent Name -
                          </span>
                          {/* - {employeeDetails?.designation} */}
                          <p style={{ color: "black", fontWeight: "bold" }}>
                            {parentdata?.user?.first_name}{" "}{parentdata?.user?.last_name}
                          </p>
                        </p>
                      </div>
                      {/* </div> */}
                    </Col>
                    <Col size="3">
                      <div
                        style={{
                          lineHeight: "13px",
                          paddingTop: "15px",
                        }}
                      >
                        <p>
                          <span style={{ color: "#999896" }}>Mobile no -</span>{" "}
                          {/* - {employeeDetails?.roleName} */}
                          <p style={{ color: "black", fontWeight: "bold" }}>
                            {parentdata?.mobile}
                          </p>
                        </p>
                      </div>
                    </Col>
                    <Col size="3">
                      <div
                        style={{
                          lineHeight: "13px",
                          paddingTop: "15px",
                        }}
                      >
                        <p>
                          <span style={{ color: "#999896" }}>Gender -</span>{" "}
                          {/* - {employeeDetails?.roleName} */}
                          <p style={{ color: "black", fontWeight: "bold" }}>
                            {parentdata?.gender}
                          </p>
                        </p>
                      </div>
                    </Col>
                    <Col size="3">
                      <div className="top-card-div">
                        <p className="card-text">
                          <span style={{ color: "#999896" }}>
                            Email Address -
                          </span>{" "}
                          <br />{" "}
                          <p style={{ color: "black", fontWeight: "bold" }}>
                          {parentdata?.user?.email}
                          </p>
                          {/* {employeeDetails?.parent_department_name}{" "} */}
                        </p>
                      </div>
                    </Col>
                  </Row>

                  <hr className="mt-0 mb-4" />
                  <Row>
                    
                    <Col size="3">
                      <div className="top-card-div">
                        <p className="card-text">
                          <span style={{ color: "#999896" }}>
                            Mode of Tuition -
                          </span>{" "}
                          <p style={{ color: "black", fontWeight: "bold" }}>
                            {parentdata?.modeOfTution}
                          </p>
                          {/* {moment(Emphist?.joining_date).format(
                                  "DD/MM/YYYY"
                                )} */}
                        </p>
                      </div>
                    </Col>
                    <Col size="3">
                      <div className="top-card-div">
                        <p className="card-text">
                          <span style={{ color: "#999896" }}>Location -</span>{" "}
                          <p style={{ color: "black", fontWeight: "bold" }}>
                            {parentdata?.location}
                          </p>
                          {/* {moment(Emphist?.joining_date).format(
                                  "DD/MM/YYYY"
                                )} */}
                        </p>
                      </div>
                    </Col>
                    <Col size="4">
                      <div className="top-card-div">
                        <p className="card-text">
                          <span style={{ color: "#999896" }}>State -</span>{" "}
                          <br />{" "}
                          <p style={{ color: "black", fontWeight: "bold" }}>
                            {parentdata?.state}
                          </p>
                          {/* {employeeDetails?.parent_department_name}{" "} */}
                        </p>
                      </div>
                    </Col>
                    <Col size="4">
                      <div className="top-card-div">
                        <p className="card-text">
                          <span style={{ color: "#999896" }}>City -</span>{" "}
                          <p style={{ color: "black", fontWeight: "bold" }}>
                            {parentdata?.city}
                          </p>
                          {/* {moment(Emphist?.joining_date).format(
                                  "DD/MM/YYYY"
                                )} */}
                        </p>
                      </div>
                    </Col>
                  </Row>
                
                  
                  <hr className="mt-0 mb-4" />
                </CardBody>
                {/* <Row className="mb-2">
                  <Col md={12}>
                    <Button
                      type="submit"
                      // style={{ float: "right", marginTop: "20px" }}
                      onClick={toggleModal4}
                      style={{
                        backgroundColor: "#080278",
                        color: "white",
                        border: "none",
                        float: "right",
                        marginRight: "20px",
                      }}
                    >
                      Edit
                    </Button>
                  </Col>
                </Row>*/}
              </div>
            </Card>
          </div>

          <div className="col mt-4">
            <Card className="shadow border">
              <CardHeader className="border-0 d-flex justify-content-between ">
                <h3 className="mb-0" style={{ color: "black" }}>
                  Student List
                </h3>
              </CardHeader>

              <Table className="align-items-center table-flush" responsive>
                <thead className="thead-light">
                  <tr>
                    <th scope="col">S.No.</th>
                    <th scope="col">Student NAME</th>
                    <th scope="col">Academic</th>
                    <th scope="col">Board</th>
                    <th scope="col">Class</th>
                    <th scope="col">Subject</th>

                    <th scope="col">Gender</th>
                    <th scope="col">Date of Birth</th>
                    <th scope="col"> School/College/University Name</th>
                    <th scope="col">Preferred Time Duration</th>
                    <th scope="col">Tuition Tenure</th>
                    <th scope="col">Location Preference</th>
                    {/* <th scope="col"> Enquiry For</th> */}
                    <th scope="col"> Loaction City</th>
                    <th scope="col"> Tutors Level</th>
                    {/*<th scope="col">Action</th>*/}
                  </tr>
                </thead>

                {true && (
                  <tbody>
                     {studentlistData?.length > 0 ? (
                        studentlistData?.map((item, index) => { 
                          console.log("smmmm",item)
                     return ( 

                    <tr key={index} style={{ cursor: "pointer" }}>
                      <td>{index + 1}</td>
                      <Link to={`/admin/Echdetaillist/${parms?.id}/${item?.id}`}><td>{item?.name || "Saurabh"}</td></Link>
                      <td>{item?.student_name || "high"}</td>
                      <td>{item?.student_name || "Mp"}</td>
                      <td>{item?.student_name || "11th"}</td>
                      <td>{item?.student_name || "Englist,Math"}</td>
                      <td>{item?.gender || "male"}</td>
                      <td> {item?.dob || "15/04/2005"}</td>
                      <td>{item?.school_name || "ssh"}</td>
                      <td>{item?.preferrd_time || "12:30 PM"}</td>
                      <td>{item?.Tuition_Tenure || " hye"}</td>
                      <td>{item?.Location_Preference || " Bhopla"}</td>
                      {/* <td  >{item?.Enquiry_For || "Student"}</td> */}
                      <td>{item?.Enquiry_For || "BHopal Kolar"}</td>
                      <td>{item?.tutor_level || "Level 1"}</td>
                     {/* <td
                        className="pl-4 p-0"
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          // justifyContent: "center",
                          // alignItems: "center",
                        }}
                      >
                        <UncontrolledTooltip
                          placement="top"
                          target="eyeTooltips"
                        >
                          Edit
                        </UncontrolledTooltip>
                        <Link
                          id="eyeTooltips"
                          style={{
                            margin: "0 5px",
                            fontSize: "15px",
                            color: "blue",
                            // backgroundColor: "#f5f5f5",
                            alignItems: "center",
                            display: "inline-block",
                            marginTop: "10px",
                            // padding: "5px", // Optional: Add padding for better appearance
                            borderRadius: "30%", // Optional: Make it a circle
                          }}
                          tag={Link}
                          to={`/admin/viewenquiry/EditEnquriParentDetails/${parms.mid}/${parms.id}/${item.id}`}
                        >
                          <i className="fa-solid fa-pen-to-square"></i>
                        </Link>

                        <UncontrolledTooltip
                          placement="top"
                          target="userTooltip"
                        >
                          Delete
                        </UncontrolledTooltip>
                        <p
                          style={{
                            margin: "0 8px",
                            fontSize: "15px",
                            color: "red",
                            marginTop: "10px",
                            // backgroundColor: "#f5f5f5",
                            display: "inline-block",
                            // padding: "5px", // Optional: Add padding for better appearance
                            borderRadius: "20%", // Optional: Make it a circle
                          }}
                          id="userTooltip"
                          // onClick={() => handleDel(item.id)}
                        >
                          <i className="fas fa-trash"></i>
                        </p>
                      </td>*/}
                      {/* <td>
                                  <UncontrolledDropdown>
                                    <DropdownToggle
                                      className="btn-icon-only text-light"
                                      role="button"
                                      size="sm"
                                      color=""
                                      // onClick={(e) => e.preventDefault()}
                                    >
                                      <i className="fas fa-ellipsis-v" />
                                    </DropdownToggle>
                                    <DropdownMenu
                                      className="dropdown-menu-arrow "
                                      right
                                    >
                                      <DropdownItem
                                        className="text-dark"
                                        //  onClick={() => toggleEditModal("Add3",item)}
                                        to={`/admin/viewenquiry`}
                                        tag={Link}
                                      >
                                        <i class="fa-solid fa-eye"></i>
                                        View
                                      </DropdownItem>
                                      <DropdownItem
                                        onClick={toggleModal1}
                                        className="text-dark"
                                      >
                                        Qualified
                                      </DropdownItem>
                                      <DropdownItem
                                        onClick={toggleModal1}
                                        className="text-dark"
                                      >
                                        Pending
                                      </DropdownItem>
                                      <DropdownItem
                                        onClick={toggleModal2}
                                        className="text-dark"
                                      >
                                        Disqualified
                                      </DropdownItem>
                                    </DropdownMenu>
                                  </UncontrolledDropdown>
                                </td> */}
                    </tr>
                     ); 
                     })
                      ) : (
                        <tr style={{ textAlign: "center" }}>
                          <td colSpan="6" style={{ verticalAlign: "middle" }}>
                            No data found
                          </td>
                        </tr>
                      )} 
                  </tbody>
                )}
              </Table>
              <CardFooter className="py-4">
                {/* <TablePagination
                   totalPages={parseInt(dataList?.meta?.total_page)}
                   currentPage={parseInt(dataList?.meta?.current_page)}
                   pageUrl="/admin/messages?"
                 /> */}
              </CardFooter>
            </Card>
          </div>

          <div className="col mt-4">
            <Card className="shadow border">
              <CardHeader className="border-0 d-flex justify-content-between ">
                <h3 className="mb-0" style={{ color: "black" }}>
                  Discovery Call
                </h3>
                <div className="d-flex flex-row">
                  <Button
                    size="sm"
                    // to="/admin/fAQs/addfAQs/"
                    // tag={Link}
                    onClick={toggleModal1}
                    style={{
                      backgroundColor: "#080278",
                      color: "white",
                      border: "none",
                    }}
                  >
                    +Add
                  </Button>
                </div>
              </CardHeader>

              <Table className="align-items-center table-flush" responsive>
                <thead className="thead-light">
                  <tr>
                    <th scope="col">S.No.</th>
                    <th scope="col">Call Done By</th>
                    <th scope="col">Call Status</th>
                    <th scope="col">Call Date</th>
                    <th scope="col">Call Time</th>
                    <th scope="col">Comment/Feedback</th>
                    {/* <th scope="col">Status</th>
                    <th>Action</th> */}
                  </tr>
                </thead>
                <tbody>
                  {discoverdata?.data.map((item, index) => {
                    
                    return (
                      <tr key ={index}>
                        <td>{index + 1}</td>
                        <td>
                          {" "}
                          <Link to="{`/admin/viewenquiry`}">{item?.auth_user?.first_name
                          }</Link>
                          {/*<span
                            style={{ marginLeft: "5px", cursor: "pointer" }}
                          >
                            {" "}
                            9302687403{" "}
                            <span style={{ marginLeft: "3px" }}>
                              <i class="fa-solid fa-phone"></i>
                            </span>
                          </span>*/}
                        </td>
                        <td>{item?.status}</td>
                        <td>{item?.date}</td>
                        <td>{item?.time}</td>
                        <td>{item?.comment}</td>
                        {/* <td>Demo Schedule</td>
                    <td className="p-0"
                      style={{
                        display: "flex",
                        flexDirection: "row",
               
                      }}
                    >
                      <UncontrolledTooltip placement="top" target="eyeTooltip">
                        Schedule Demo
                      </UncontrolledTooltip>
                      <Link
                          style={{
                            margin: "0 5px",
                            fontSize: "15px",
                            color: "blue",
                            // backgroundColor: "#f5f5f5",
                            alignItems:"center",
                            display: "inline-block",
                            marginTop:"10px",
                            // padding: "5px", // Optional: Add padding for better appearance
                            borderRadius: "30%", // Optional: Make it a circle
                          }}
                        id="eyeTooltip"
                        onClick={toggleModal1}
                        // tag={Link}
                      >
                        <i class="fa-solid fa-calendar-days"></i>
                      </Link>

                      <UncontrolledTooltip placement="top" target="userTooltip">
                        Demo Given
                      </UncontrolledTooltip>
                      <p
                         style={{
                          margin: "0 5px",
                          fontSize: "15px",
                          color: "blue",
                          // backgroundColor: "#f5f5f5",
                          alignItems:"center",
                          display: "inline-block",
                          marginTop:"10px",
                          // padding: "5px", // Optional: Add padding for better appearance
                          borderRadius: "30%", // Optional: Make it a circle
                        }}
                        id="userTooltip"
                        onClick={toggleModal2}
                      >
                        <i class="fa-regular fa-id-card"></i>
                      </p>

                      <UncontrolledTooltip placement="top" target="CreatePackage">
                        Create Package
                      </UncontrolledTooltip>
                      <p
                         style={{
                          margin: "0 5px",
                          fontSize: "15px",
                          color: "blue",
                          // backgroundColor: "#f5f5f5",
                          alignItems:"center",
                          display: "inline-block",
                          marginTop:"10px",
                          // padding: "5px", // Optional: Add padding for better appearance
                          borderRadius: "30%", // Optional: Make it a circle
                        }}
                        id="CreatePackage"
                        onClick={toggleModal5}
                      >
                        <i class="fa-solid fa-hand-holding-heart"></i>
                      </p>
                      <UncontrolledTooltip placement="top" target="CreateClass">
                        Create Class
                      </UncontrolledTooltip>
                      <Link
                          style={{
                            margin: "0 5px",
                            fontSize: "15px",
                            color: "blue",
                            // backgroundColor: "#f5f5f5",
                            alignItems:"center",
                            display: "inline-block",
                            marginTop:"10px",
                            // padding: "5px", // Optional: Add padding for better appearance
                            borderRadius: "30%", // Optional: Make it a circle
                          }}
                        to={`/admin/classes/addclasss`}

                        id="CreateClass"
                        // onClick={toggleModal2}
                      >
                       <i class="fa-solid fa-plus"></i>
                      </Link>
                    </td> */}
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
              <CardFooter className="py-4">
                {/* <TablePagination
                    totalPages={parseInt(dataList?.meta?.total_page)}
                    currentPage={parseInt(dataList?.meta?.current_page)}
                    pageUrl="/admin/messages?"
                  /> */}
              </CardFooter>
            </Card>
          </div>

          <div className="col mt-4">
            <Card className="shadow">
              <CardHeader className="border-0 d-flex justify-content-between ">
                <h3 className="mb-0" style={{ color: "black" }}>
                  EHC Coordination
                </h3>
                <div className="d-flex flex-row">
                  <Button
                    size="sm"
                    onClick={toggleModal2}
                    style={{
                      backgroundColor: "#080278",
                      color: "white",
                      border: "none",
                    }}
                  >
                    +Add
                  </Button>
                </div>
              </CardHeader>

              <Table className="align-items-center table-flush" responsive>
                <thead className="thead-light">
                  <tr>
                    <th scope="col">S.No.</th>
                    <th scope="col">Supervisor</th>
                    <th scope="col">Date</th>
                    <th scope="col">Time Slot</th>
                    <th scope="col">Comment/Feedback</th>
                    <th scope="col">EHC Name</th>
                    {/*<th>Action</th>
                    <th scope="col" />*/}
                  </tr>
                </thead>
                <tbody>
                  {cordinationdata?.data?.map((item, index)=>{
                    console.log("startsss",item)
                    return(
                    <tr>
                    <td key={index}>{index + 1}</td>
                    <td className="p-0 pl-5">
                      {" "}
                     {item?.auth_user?.first_name}
                      {/*<span style={{ marginLeft: "5px", cursor: "pointer" }}>
                        {" "}
                        9302687403{" "}
                        <span style={{ marginLeft: "3px" }}>
                          <i class="fa-solid fa-phone"></i>
                        </span>
                      </span>
                       */}
                    </td>
                    <td>{item?.date}</td>
                    <td>{item?.time}</td>
                    <td>{item?.comment}</td>
                    <td>{item?.ehc_name}</td>

                   {/*  <td
                      className="p-0 pl-4"
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        // justifyContent: "center",
                        // alignItems: "center",
                      }}
                    >*/}
                      {/* <UncontrolledTooltip
                                  placement="top"
                                  target="eyeTooltip"
                                >
                                  Edit
                                </UncontrolledTooltip>
                                <Link
                                  style={{
                                    margin: "0 5px",
                                    fontSize: "15px",
                                    color: "blue",
                                    // backgroundColor: "#f5f5f5",
                                    alignItems: "center",
                                    display: "inline-block",
                                    marginTop: "10px",
                                    // padding: "5px", // Optional: Add padding for better appearance
                                    borderRadius: "30%", // Optional: Make it a circle
                                  }}
                                  id="eyeTooltip"
                                  to={`/admin/classes/editclasss/${item?.id}`}
                                >
                                  <i className="fa-solid fa-pen-to-square"></i>
                                </Link> */}

                    {/*  <UncontrolledTooltip placement="top" target="userTooltip">
                        Delete
                      </UncontrolledTooltip>
                      <p
                        style={{
                          margin: "0 8px",
                          fontSize: "15px",
                          color: "red",
                          marginTop: "10px",
                          // backgroundColor: "#f5f5f5",
                          display: "inline-block",
                          // padding: "5px", // Optional: Add padding for better appearance
                          borderRadius: "20%", // Optional: Make it a circle
                        }}
                        id="userTooltip"
                        onClick={() => handleDel(item.id)}
                      >
                        <i className="fas fa-trash"></i>
                      </p>
                    </td> */}
                  </tr>
                    )
                  })}
                  
                </tbody>
              </Table>
              <CardFooter className="py-4">
                {/* <TablePagination
                    totalPages={parseInt(dataList?.meta?.total_page)}
                    currentPage={parseInt(dataList?.meta?.current_page)}
                    pageUrl="/admin/messages?"
                  /> */}
              </CardFooter>
            </Card>
          </div>

          <div className="col-12 mt-4">
            <Card className="shadow">
              <CardHeader className="border-0 d-flex justify-content-between ">
                <h3 className="mb-0" style={{ color: "black" }}>
                  EHC Test (To be filled by Study Supervisor)
                </h3>

              </CardHeader>
              <CardBody>
                <Form onSubmit={EchTest}>
                  <Row>
                    <Col md={12}>
                    <FormGroup>
                      <Label>EHC Name</Label>
                      <Input type="select"
                      name="coordination_id">
                      <option>select</option>
                      {cordinationdata?.data?.map((item, index)=>{
                   
                    return( 
                        <>
                      <option value={item?.id} key={index}>{item?.ehc_name}</option>
                      </>
                    )})}
                    </Input>
                    </FormGroup></Col>
                    
                  </Row>
                <Row>
                  <Col md={6}>
                    <FormGroup>
                      <Label>EHC Date</Label>
                      <Input
                        name="date"
                        style={{
                          border: "1px solid lightgrey",
                          padding: "6px 10px",
                          borderRadius: "6px",
                        }}
                        type="date"
                   
                       
                        
                      />
                    </FormGroup>
                  </Col>
                  <Col md={6}>
                    <FormGroup>
                      <Label>EHC Time</Label>
                      <Input
                        style={{
                          border: "1px solid lightgrey",
                          padding: "6px 10px",
                          borderRadius: "6px",
                        }}
                        type="time"
                        id="name"
                        name="time"
                        
                      />
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col md={4}>
                    <FormGroup>
                      <Label for="exampleEmail">Study Supervisor</Label>
                      <Input  name="supervisor_id" type="select">
                        <option value="">Select Study Supervisor </option>
                        {supervisorlistdata?.data?.map((item, index)=>{
                      
                      return(
                        <option value={item?.user_id}>{item?.auth_user?.first_name} {" "} {item?.auth_user?.last_name}</option>

                      )
                    })}
                      </Input>
                    </FormGroup>
                  </Col>
                  <Col md={4}>
                    <FormGroup>
                      <Label >Status</Label>
                      <Input  name="status" type="select">
                        <option value="">Select Status</option>
                        <option value="done">done </option>
                        <option value="not done">not done </option>
                        
                      </Input>
                    </FormGroup>
                  </Col>
                  <Col md={4}>
                    <FormGroup>
                      <Label>Remark</Label>
                      <Input
                        style={{
                          border: "1px solid lightgrey",
                          padding: "6px 10px",
                          borderRadius: "6px",
                        }}
                        type="textarea"
                       
                        name="remarks"
                        placeholder="Enter Remark"
                      />
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col md={12} className="d-flex justify-content-center">
                  <Button type="submit"  style={{
                        backgroundColor: "#080278",
                        color: "white",
                        border: "none",
                        float: "right",
                        marginRight: "20px",
                      }} >
                    Submit
                    </Button>
                    </Col>
                </Row>
                </Form>
                </CardBody>
                </Card>
                </div>
                <div className="col-12 mt-4">
          
                <Card className="shadow">
                <Form onSubmit={ReportSubmit}>
              <CardHeader className="border-0 d-flex flex-column ">
                <h3 className="mb-0" style={{ color: "black",}}>
                EHC Report
                </h3>
                <Row className="mt-4">
                  <Col md={4}>
                  <Input type="select" name="student_id">
                  <option>Select Student</option>
                  {studentlistData?.map((item, index) => { 
                   
                     return (
                     <option key={index} value={item?.id}>{item?.name}</option>

                     ) })}
                  
                  </Input>
                  </Col>
                  <Col md={4}>
                 
                  <Input type="select" name="coordination_id">
                  <option>Select ECH Name</option>
                  {cordinationdata?.data?.map((item, index)=>{
                   
                   return( 
                       <>
                     <option value={item?.id} key={index}>{item?.ehc_name}</option>
                     </>
                   )})}
                  </Input>
                  </Col>
                </Row>
              </CardHeader>
                <CardBody>
               
                <div>
                  <Row>
                    <Col md={12}>
                      <p
                        style={{
                          fontWeight: "bold",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          backgroundColor: "lightgray",
                        }}
                      >
                        A. General Overview
                      </p>{" "}
                    </Col>
                  </Row>
                  <Row>
                    <Col
                      md={3}
                      style={{
                        fontWeight: "bold",
                        display: "flex",
                        alignItems: "center",
                        //   justifyContent: "center",
                        marginTop: "10px",
                      }}
                    >
                      {" "}
                      <FormGroup>
                        <Label>
                          Concept of Understanding
                        </Label>
                      </FormGroup>
                    </Col>
                    <Col md={3}>
                      {" "}
                      <FormGroup>
                        <Label>Marks</Label>
                        <Input
                          style={{
                            
                            border: "1px solid lightgrey",
                            padding: "6px 10px",
                            borderRadius: "6px",
                          }}
  
                          name="marks"
                          type="number"
                          
                          value={concept_of_understanding.marks}
                          onChange={handleChangeconceptUnderstanding}
                          placeholder="Enter Marks"
                        />
                      </FormGroup>
                    </Col>
                    <Col md={3}>
                      <FormGroup>
                        <Label>Total</Label>
                        <Input
                        name="total"
                          style={{
                            border: "1px solid lightgrey",
                            padding: "6px 10px",
                            borderRadius: "6px",
                          }}
                          
                          type="number"
                          value={concept_of_understanding.total}
                          onChange={handleChangeconceptUnderstanding}
                          placeholder="Enter Total"
                        />
                      </FormGroup>
                    </Col>
                    <Col md={3}>
                      <FormGroup>
                        <Label>Remark</Label>
                        <Input
                          style={{
                            border: "1px solid lightgrey",
                            padding: "6px 10px",
                            borderRadius: "6px",
                          }}
                          name="remark"
                          type="textarea"
                          value={concept_of_understanding.remark}
                          onChange={handleChangeconceptUnderstanding}
                          placeholder="Enter Remark"
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col
                      md={3}
                      style={{
                        fontWeight: "bold",
                        display: "flex",
                        alignItems: "center",
                        //   justifyContent: "center",
                        marginTop: "10px",
                      }}
                    >
                      {" "}
                      <FormGroup>
                        <Label for="exampleEmail">
                          Tuition Copy Maintenance
                        </Label>
                      </FormGroup>
                    </Col>
                    <Col md={3}>
                      {" "}
                      <FormGroup>
                        <Label>Marks</Label>
                        <Input
                          style={{
                            border: "1px solid lightgrey",
                            padding: "6px 10px",
                            borderRadius: "6px",
                          }}
                          type="number"
                          name="marks"
                          value={tuition_copy_maintenance.marks}
                          onChange={handleChangetutionManintance}
                          placeholder="Enter Marks"
                        />
                      </FormGroup>
                    </Col>
                    <Col md={3}>
                      <FormGroup>
                        <Label>Total</Label>
                        <Input
                          style={{
                            border: "1px solid lightgrey",
                            padding: "6px 10px",
                            borderRadius: "6px",
                          }}
                          type="number"
                          name="total"
                          value={tuition_copy_maintenance.total}
                          onChange={handleChangetutionManintance}
                          placeholder="Enter Total"
                        />
                      </FormGroup>
                    </Col>
                    <Col md={3}>
                      <FormGroup>
                        <Label >Remark</Label>
                        <Input
                          style={{
                            border: "1px solid lightgrey",
                            padding: "6px 10px",
                            borderRadius: "6px",
                          }}
                          name="remark"
                          type="textarea"
                          value={tuition_copy_maintenance.remark}
                          onChange={handleChangetutionManintance}
                          placeholder="Enter Remark"
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col
                      md={3}
                      style={{
                        fontWeight: "bold",
                        display: "flex",
                        alignItems: "center",

                        marginTop: "10px",
                      }}
                    >
                      {" "}
                      <FormGroup>
                        <Label>Syllabus Coverage</Label>
                      </FormGroup>
                    </Col>
                    <Col md={3}>
                      {" "}
                      <FormGroup>
                        <Label for="exampleEmail">Marks</Label>
                        <Input
                          style={{
                            border: "1px solid lightgrey",
                            padding: "6px 10px",
                            borderRadius: "6px",
                          }}
                          
                          name="marks"
                          type="number"
                          
                          value={syllabus_coverage.marks}
                          onChange={handleChangesyllabus_coverage}
                          placeholder="Enter Marks"
                        />
                      </FormGroup>
                    </Col>
                    <Col md={3}>
                      <FormGroup>
                        <Label>Total</Label>
                        <Input
                          style={{
                            border: "1px solid lightgrey",
                            padding: "6px 10px",
                            borderRadius: "6px",
                          }}
                          type="number"
                          value={syllabus_coverage.total}
                          onChange={handleChangesyllabus_coverage}
                          name="total"
                          placeholder="Enter Total"
                        />
                      </FormGroup>
                    </Col>
                    <Col md={3}>
                      <FormGroup>
                        <Label>Remark</Label>
                        <Input
                          style={{
                            border: "1px solid lightgrey",
                            padding: "6px 10px",
                            borderRadius: "6px",
                          }}
                          type="textarea"
                          value={syllabus_coverage.remark}
                          onChange={handleChangesyllabus_coverage}
                          name="remark"
                          placeholder="Enter Remark"
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                </div>

                <div className="mt-4">
                  <Row>
                    <Col md={12}>
                      <p
                        style={{
                          fontWeight: "bold",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          backgroundColor: "lightgray",
                        }}
                      >
                        B. Answersheet Analysis
                      </p>{" "}
                    </Col>
                  </Row>
                  <Row>
                    <Col
                      md={3}
                      style={{
                        fontWeight: "bold",
                        display: "flex",
                        alignItems: "center",
                        //   justifyContent: "center",
                        marginTop: "10px",
                      }}
                    >
                      {" "}
                      <FormGroup>
                        <Label for="exampleEmail">
                          Concepts/Chapters Clarity
                        </Label>
                      </FormGroup>
                    </Col>

                    <Col md={3}>
                      {" "}
                      <FormGroup>
                        <Label for="exampleEmail">Marks</Label>
                        <Input
                          style={{
                            border: "1px solid lightgrey",
                            padding: "6px 10px",
                            borderRadius: "6px",
                          }}
                          type="number"
                          
                          value={concept_clarity.marks}
                          onChange={handleChangeconcept_clarity}
                          name="marks"
                          placeholder="Enter Marks"
                        />
                      </FormGroup>
                    </Col>
                    <Col md={3}>
                      <FormGroup>
                        <Label>Total</Label>
                        <Input
                          style={{
                            border: "1px solid lightgrey",
                            padding: "6px 10px",
                            borderRadius: "6px",
                          }}
                          type="number"
                          value={concept_clarity.total}
                          onChange={handleChangeconcept_clarity}
                          name="total"
                          placeholder="Enter Total"
                        />
                      </FormGroup>
                    </Col>
                    <Col md={3}>
                      <FormGroup>
                        <Label>Remark</Label>
                        <Input
                          style={{
                            border: "1px solid lightgrey",
                            padding: "6px 10px",
                            borderRadius: "6px",
                          }}
                          type="textarea"
                          name="remark"
                          value={concept_clarity.remark}
                          onChange={handleChangeconcept_clarity}
                          placeholder="Enter Remark"
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col
                      md={3}
                      style={{
                        fontWeight: "bold",
                        display: "flex",
                        alignItems: "center",
                        //   justifyContent: "center",
                        marginTop: "10px",
                      }}
                    >
                      {" "}
                      <FormGroup>
                        <Label >Time Management</Label>
                      </FormGroup>
                    </Col>

                    <Col md={3}>
                      {" "}
                      <FormGroup>
                        <Label>Marks</Label>
                        <Input
                          style={{
                            border: "1px solid lightgrey",
                            padding: "6px 10px",
                            borderRadius: "6px",
                          }}
                          type="number"
                          name="marks"
                          value={time_management.marks}
                          onChange={handleChangetime_management}
                          placeholder="Enter Marks"
                        />
                      </FormGroup>
                    </Col>
                    <Col md={3}>
                      <FormGroup>
                        <Label>Total</Label>
                        <Input
                          style={{
                            border: "1px solid lightgrey",
                            padding: "6px 10px",
                            borderRadius: "6px",
                          }}
                          type="number"
                          name="total"
                          value={time_management.total}
                          onChange={handleChangetime_management}
                          placeholder="Enter Total"
                        />
                      </FormGroup>
                    </Col>
                    <Col md={3}>
                      <FormGroup>
                        <Label >Remark</Label>
                        <Input
                          style={{
                            border: "1px solid lightgrey",
                            padding: "6px 10px",
                            borderRadius: "6px",
                          }}
                          type="textarea"
                          name="remark"
                          value={time_management.remark}
                          onChange={handleChangetime_management}
                          placeholder="Enter Remark"
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col
                      md={3}
                      style={{
                        fontWeight: "bold",
                        display: "flex",
                        alignItems: "center",

                        marginTop: "10px",
                      }}
                    >
                      {" "}
                      <FormGroup>
                        <Label>Presentation Skills</Label>
                      </FormGroup>
                    </Col>

                    <Col md={3}>
                      {" "}
                      <FormGroup>
                        <Label for="exampleEmail">Marks</Label>
                        <Input
                          style={{
                            border: "1px solid lightgrey",
                            padding: "6px 10px",
                            borderRadius: "6px",
                          }}
                          type="number"
                          name="marks"
                          value={presentation_skills.marks}
                          onChange={handleChangepresentation_skills}
                          placeholder="Enter Marks"
                        />
                      </FormGroup>
                    </Col>
                    <Col md={3}>
                      <FormGroup>
                        <Label>Total</Label>
                        <Input
                          style={{
                            border: "1px solid lightgrey",
                            padding: "6px 10px",
                            borderRadius: "6px",
                          }}
                          type="number"
                          name="total"
                          value={presentation_skills.total}
                          onChange={handleChangepresentation_skills}
                          placeholder="Enter Total"
                        />
                      </FormGroup>
                    </Col>
                    <Col md={3}>
                      <FormGroup>
                        <Label>Remark</Label>
                        <Input
                          style={{
                            border: "1px solid lightgrey",
                            padding: "6px 10px",
                            borderRadius: "6px",
                          }}
                          type="textarea"
                          name="remark"
                          value={presentation_skills.remark}
                          onChange={handleChangepresentation_skills}
                          placeholder="Enter Remark"
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col
                      md={3}
                      style={{
                        fontWeight: "bold",
                        display: "flex",
                        alignItems: "center",

                        marginTop: "10px",
                      }}
                    >
                      {" "}
                      <FormGroup>
                        <Label for="exampleEmail">Question Understanding</Label>
                      </FormGroup>
                    </Col>

                    <Col md={3}>
                      {" "}
                      <FormGroup>
                        <Label for="exampleEmail">Marks</Label>
                        <Input
                          style={{
                            border: "1px solid lightgrey",
                            padding: "6px 10px",
                            borderRadius: "6px",
                          }}
                          type="number"
                          name="marks"
                          value={question_understanding.marks}
                          onChange={handleChangequestion_understanding}
                          placeholder="Enter Marks"
                        />
                      </FormGroup>
                    </Col>
                    <Col md={3}>
                      <FormGroup>
                        <Label>Total</Label>
                        <Input
                          style={{
                            border: "1px solid lightgrey",
                            padding: "6px 10px",
                            borderRadius: "6px",
                          }}
                          type="number"
                          name="total"
                          value={question_understanding.total}
                          onChange={handleChangequestion_understanding}
                          placeholder="Enter Total"
                        />
                      </FormGroup>
                    </Col>
                    <Col md={3}>
                      <FormGroup>
                        <Label>Remark</Label>
                        <Input
                          style={{
                            border: "1px solid lightgrey",
                            padding: "6px 10px",
                            borderRadius: "6px",
                          }}
                          type="textarea"
                          
                          name="remark"
                          value={question_understanding.remark}
                          onChange={handleChangequestion_understanding}
                          placeholder="Enter Remark"
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                </div>
                <div className="mt-4">
                  <Row>
                    <Col md={12}>
                      <p
                        style={{
                          fontWeight: "bold",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          backgroundColor: "lightgray",
                        }}
                      >
                        C. Parent's Feedback
                      </p>{" "}
                    </Col>
                  </Row>
                  <Row>
                    <Col
                      md={4}
                      style={{
                        fontWeight: "bold",
                        display: "flex",
                        alignItems: "center",
                        //   justifyContent: "center",
                        marginTop: "10px",
                      }}
                    >
                      {" "}
                      <FormGroup>
                        <Label>Regularity of Educator</Label>
                      </FormGroup>
                    </Col>

                    <Col md={8}>
                      {" "}
                      <FormGroup>
                        <Input
                          style={{
                            border: "1px solid lightgrey",
                            padding: "6px 10px",
                            borderRadius: "6px",
                          }}
                          type="text"
                        
                          name="regularity_of_educator"
                          placeholder="Enter Feedback"
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col
                      md={4}
                      style={{
                        fontWeight: "bold",
                        display: "flex",
                        alignItems: "center",
                        //   justifyContent: "center",
                        marginTop: "10px",
                      }}
                    >
                      {" "}
                      <FormGroup>
                        <Label>Attendence tracking</Label>
                      </FormGroup>
                    </Col>

                    <Col md={8}>
                      {" "}
                      <FormGroup>
                        <Input
                          style={{
                            border: "1px solid lightgrey",
                            padding: "6px 10px",
                            borderRadius: "6px",
                          }}
                          type="text"
                          
                          name="attendance_tracking"
                          placeholder="Enter Feedback"
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col
                      md={4}
                      style={{
                        fontWeight: "bold",
                        display: "flex",
                        alignItems: "center",

                        marginTop: "10px",
                      }}
                    >
                      {" "}
                      <FormGroup>
                        <Label>Weaker Area/ Teacher Complaint</Label>
                      </FormGroup>
                    </Col>

                    <Col md={8}>
                      {" "}
                      <FormGroup>
                        <Input
                          style={{
                            border: "1px solid lightgrey",
                            padding: "6px 10px",
                            borderRadius: "6px",
                          }}
                          type="text"
                          
                          name="weaker_areas"
                          placeholder="Enter Feedback"
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col
                      md={4}
                      style={{
                        fontWeight: "bold",
                        display: "flex",
                        alignItems: "center",

                        marginTop: "10px",
                      }}
                    >
                      {" "}
                      <FormGroup>
                        <Label>Student's Self Study Time</Label>
                      </FormGroup>
                    </Col>

                    <Col md={8}>
                      {" "}
                      <FormGroup>
                        <Input
                          style={{
                            border: "1px solid lightgrey",
                            padding: "6px 10px",
                            borderRadius: "6px",
                          }}
                          type="text"
                          
                          name="self_studdy_time"
                          placeholder="Enter Feedback"
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col
                      md={4}
                      style={{
                        fontWeight: "bold",
                        display: "flex",
                        alignItems: "center",

                        marginTop: "10px",
                      }}
                    >
                      {" "}
                      <FormGroup>
                        <Label>Suggestion</Label>
                      </FormGroup>
                    </Col>

                    <Col md={8}>
                      {" "}
                      <FormGroup>
                        <Input
                          style={{
                            border: "1px solid lightgrey",
                            padding: "6px 10px",
                            borderRadius: "6px",
                          }}
                          type="text"
                         
                          name="suggestion"
                          placeholder="Enter Feedback"
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col
                      md={4}
                      style={{
                        fontWeight: "bold",
                        display: "flex",
                        alignItems: "center",

                        marginTop: "10px",
                      }}
                    >
                      {" "}
                      <FormGroup>
                        <Label>Feedback/Complaints/Queries</Label>
                      </FormGroup>
                    </Col>

                    <Col md={8}>
                      {" "}
                      <FormGroup>
                        <Input
                          style={{
                            border: "1px solid lightgrey",
                            padding: "6px 10px",
                            borderRadius: "6px",
                          }}
                          type="text"
                          id="name"
                          name="feedback_complaints"
                          placeholder="Enter Feedback"
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  
                
                </div>
                <div className="mt-4">
                 
                  <Row>
                    <Col md={12}>
                      <p
                        style={{
                          fontWeight: "bold",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          backgroundColor: "lightgray",
                        }}
                      >
                        D. Answer Sheet Added
                      </p>{" "}
                    </Col>
                  </Row>
                  <Row>
                    <Col
                      md={4}
                      style={{
                        fontWeight: "bold",
                        display: "flex",
                        alignItems: "center",
                        //   justifyContent: "center",
                        marginTop: "10px",
                      }}
                    >
                      {" "}
                      <FormGroup>
                        <Label>Answer 1</Label>
                      </FormGroup>
                    </Col>

                    <Col md={8}>
                      {" "}
                      <FormGroup>
                        <Input
                          style={{
                            border: "1px solid lightgrey",
                            padding: "6px 10px",
                            borderRadius: "6px",
                          }}
                          type="file"
                          
                          name="sheet_1"
                          placeholder="Enter Feedback"
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col
                      md={4}
                      style={{
                        fontWeight: "bold",
                        display: "flex",
                        alignItems: "center",
                        //   justifyContent: "center",
                        marginTop: "10px",
                      }}
                    >
                      {" "}
                      <FormGroup>
                        <Label>Answer 2</Label>
                      </FormGroup>
                    </Col>

                    <Col md={8}>
                      {" "}
                      <FormGroup>
                        <Input
                          style={{
                            border: "1px solid lightgrey",
                            padding: "6px 10px",
                            borderRadius: "6px",
                          }}
                          type="file"
                        
                          name="sheet_2"
                          placeholder="Enter Feedback"
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col
                      md={4}
                      style={{
                        fontWeight: "bold",
                        display: "flex",
                        alignItems: "center",

                        marginTop: "10px",
                      }}
                    >
                      {" "}
                      <FormGroup>
                        <Label>Answer 3</Label>
                      </FormGroup>
                    </Col>

                    <Col md={8}>
                      {" "}
                      <FormGroup>
                        <Input
                          style={{
                            border: "1px solid lightgrey",
                            padding: "6px 10px",
                            borderRadius: "6px",
                          }}
                          type="file"
                          name="sheet_3"
                          
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col
                      md={4}
                      style={{
                        fontWeight: "bold",
                        display: "flex",
                        alignItems: "center",

                        marginTop: "10px",
                      }}
                    >
                      {" "}
                      <FormGroup>
                        <Label>Answer 4</Label>
                      </FormGroup>
                    </Col>

                    <Col md={8}>
                      {" "}
                      <FormGroup>
                        <Input
                          style={{
                            border: "1px solid lightgrey",
                            padding: "6px 10px",
                            borderRadius: "6px",
                          }}
                          type="file"
                          
                          name="sheet_4"
                          
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  
                  <Row>
                  <Col md={12}>
                    <Button
                      type="submit"
                      style={{
                        float: "right",
                        marginLeft: "5%",
                        backgroundColor: "#080278",
                        color: "white",
                        border: "none",
                      }}
                      // onClick={}
                    >
                      Submit
                    </Button>
                  </Col>
                  </Row>
                 
                </div>
               
              </CardBody>
              </Form>
            </Card>
          </div>

        {/*Raise Complain*/}
          <div className="col-12 mt-4">
            <Card>
              <CardHeader>
              <Row>
                    <Col md={6}>
                      <Label>Raise Complaint (YES/NO)</Label>
                    </Col>

                    <Col
                      md={3}
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-evenly",
                      }}
                    >
                      <Label htmlFor="yesCheckbox">Yes</Label>
                      <input
                        id="yesCheckbox"
                        type="checkbox"
                        checked={isChecked}
                        onChange={handleCheckboxChange}
                        style={{
                          fontSize: "20px",
                          padding: "0px",
                          height: "25px",
                          width: "25px",
                        }}
                      />{" "}
                      /<Label htmlFor="noCheckbox">No</Label>
                      <input
                        id="noCheckbox"
                        type="checkbox"
                        checked={!isChecked}
                        onChange={handleCheckboxChange}
                        style={{
                          fontSize: "20px",
                          padding: "0px",
                          height: "25px",
                          width: "25px",
                        }}
                      />
                    </Col>
                  </Row>
              </CardHeader>
              <CardBody>
                 <Form onSubmit={RaiseComplain}>
              {isChecked && (
                    <Row className="mt-4">
                      <Col md={6}>
                        {" "}
                        <FormGroup>
                          <Label >Subject</Label>
                          <Input  name="subject" type="select">
                            <option value="">Select Subject </option>
                            <option value="tutor">Tutor</option>
                            <option value="student">Student</option>
                          </Input>
                        </FormGroup>
                      </Col>
                      <Col md={6}>
                        {" "}
                        <FormGroup>
                          <Label>Complaint/Feedback</Label>
                          <Input
                            style={{
                              border: "1px solid lightgrey",
                              padding: "6px 10px",
                              borderRadius: "6px",
                            }}
                            type="textarea"
                            
                            name="complaint"
                            placeholder="Enter Complaint/Feedback"
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                  )}
                  {isChecked &&    <Row>
                  <Col md={12}>
                    <Button
                      type="submit"
                      style={{
                        float: "right",
                        marginLeft: "5%",
                        backgroundColor: "#080278",
                        color: "white",
                        border: "none",
                      }}
                      // onClick={}
                    >
                      Submit
                    </Button>
                  </Col>
                </Row>}
                </Form>
              </CardBody>
            </Card>
          </div>
          <div className="col-12 mt-4">
            <Card className="shadow">
              <Form onSubmit={SwortForm }>
              <CardHeader className="border-0 d-flex flex-column ">
                <Row> <Col ><h3 className="mb-0" style={{ color: "black" }}>
                  EHC SWOT Report (To be filled by Coach)
                </h3></Col></Row>
                <Row className="mt-4">
                
                  <Col  md={4}>
                  <Input type="select" name="ehc_report_id">
                  <option>Select ECH Report</option>
  
            {EchRepotlist?.data?.map((item, index)=>{
              
              return(
                <option value={item?.id} key={index}>{item?.ehc_coordination?.ehc_name}</option>
              )
            })}
                  </Input>
                  </Col>
                </Row>
              </CardHeader>
              <CardBody>
                <Row>
                  <Col md={12}>
                    <p
                      style={{
                        fontWeight: "bold",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        backgroundColor: "lightgray",
                      }}
                    >
                      A. Academic Report
                    </p>{" "}
                  </Col>
                </Row>
                <Row>
                  <Col md={3}>
                    <FormGroup>
                      <Label>Subject</Label>
                      <Input
                        style={{
                          border: "1px solid lightgrey",
                          padding: "6px 10px",
                          borderRadius: "6px",
                        }}
                        type="text"
                        value={subject_1.subject_name}
                        onChange={handleChangesubject_1}
                        name="subject_name"
                        placeholder="Enter Subject"
                      />
                      <Input
                        style={{
                          border: "1px solid lightgrey",
                          padding: "6px 10px",
                          borderRadius: "6px",
                          marginTop: "20px",
                        }}
                        type="text"
                        value={subject_2.subject_name}
                        onChange={handleChangesubject_2}
                        name="subject_name"
                        placeholder="Enter Subject"
                      />
                      <Input
                        style={{
                          border: "1px solid lightgrey",
                          padding: "6px 10px",
                          borderRadius: "6px",
                          marginTop: "20px",
                        }}
                        type="text"
                        value={subject_3.subject_name}
                        onChange={handleChangesubject_3}
                        name="subject_name"
                        placeholder="Enter Subject"
                      />
                      <Input
                        style={{
                          border: "1px solid lightgrey",
                          padding: "6px 10px",
                          borderRadius: "6px",
                          marginTop: "20px",
                        }}
                        type="text"
                        value={subject_4.subject_name}
                        onChange={handleChangesubject_4}
                        name="subject_name"
                        placeholder="Enter Subject"
                      />
                    </FormGroup>
                  </Col>
                  <Col md={3}>
                    <FormGroup>
                      <Label for="exampleEmail">Total Question</Label>
                      <Input
                        style={{
                          border: "1px solid lightgrey",
                          padding: "6px 10px",
                          borderRadius: "6px",
                        }}
                        type="text"
                        name="question"
                        value={subject_1.question}
                        onChange={handleChangesubject_1}
                        placeholder="Enter Question"
                      />
                      <Input
                        style={{
                          border: "1px solid lightgrey",
                          padding: "6px 10px",
                          borderRadius: "6px",
                          marginTop: "20px",
                        }}
                        type="text"
                        name="question"
                        value={subject_2.question}
                        onChange={handleChangesubject_2}
                        placeholder="Enter Question"
                      />
                      <Input
                        style={{
                          border: "1px solid lightgrey",
                          padding: "6px 10px",
                          borderRadius: "6px",
                          marginTop: "20px",
                        }}
                        type="text"
                        name="question"
                        value={subject_3.question}
                        onChange={handleChangesubject_3}
                        placeholder="Enter Question"
                      />
                       <Input
                        style={{
                          border: "1px solid lightgrey",
                          padding: "6px 10px",
                          borderRadius: "6px",
                          marginTop: "20px",
                        }}
                        type="text"
                        name="question"
                        value={subject_4.question}
                        onChange={handleChangesubject_4}
                        placeholder="Enter Question"
                      />
                    </FormGroup>
                  </Col>
                  <Col md={3}>
                    <FormGroup>
                      <Label for="exampleEmail">Total Marks</Label>
                      <Input
                        style={{
                          border: "1px solid lightgrey",
                          padding: "6px 10px",
                          borderRadius: "6px",
                        }}
                        type="number"
                        name="total_marks"
                        value={subject_1.total_marks}
                        onChange={handleChangesubject_1}
                        placeholder="Enter Question"
                        
                      />

                      <Input
                        style={{
                          border: "1px solid lightgrey",
                          padding: "6px 10px",
                          borderRadius: "6px",
                          marginTop: "20px",
                        }}
                        type="number"
                        name="total_marks"
                        value={subject_2.total_marks}
                        onChange={handleChangesubject_2}
                        placeholder="Enter marks"
                      />
                      <Input
                        style={{
                          border: "1px solid lightgrey",
                          padding: "6px 10px",
                          borderRadius: "6px",
                          marginTop: "20px",
                        }}
                        type="number"
                        name="total_marks"
                        value={subject_3.total_marks}
                        onChange={handleChangesubject_3}
                        placeholder="Enter marks"
                      />
                      <Input
                        style={{
                          border: "1px solid lightgrey",
                          padding: "6px 10px",
                          borderRadius: "6px",
                          marginTop: "20px",
                        }}
                        type="number"
                        name="total_marks"
                        value={subject_4.total_marks}
                        onChange={handleChangesubject_4}
                        placeholder="Enter marks"
                      />
                    </FormGroup>
                  </Col>
                  <Col md={3}>
                    <FormGroup>
                      <Label>Marks</Label>
                      <Input
                        style={{
                          border: "1px solid lightgrey",
                          padding: "6px 10px",
                          borderRadius: "6px",
                        }}
                        type="number"
                        name="marks"
                        value={subject_1.marks}
                        onChange={handleChangesubject_1}
                        placeholder="Enter Question"
                      />

                      <Input
                        style={{
                          border: "1px solid lightgrey",
                          padding: "6px 10px",
                          borderRadius: "6px",
                          marginTop: "20px",
                        }}
                        type="number"
                        name="marks"
                        value={subject_2.marks}
                        onChange={handleChangesubject_2}
                        placeholder="Enter marks"
                      />
                      <Input
                        style={{
                          border: "1px solid lightgrey",
                          padding: "6px 10px",
                          borderRadius: "6px",
                          marginTop: "20px",
                        }}
                        type="number"
                        name="marks"
                        value={subject_3.marks}
                        onChange={handleChangesubject_3}
                        placeholder="Enter marks"
                      />
                      <Input
                        style={{
                          border: "1px solid lightgrey",
                          padding: "6px 10px",
                          borderRadius: "6px",
                          marginTop: "20px",
                        }}
                        type="number"
                        name="marks"
                        value={subject_4.marks}
                        onChange={handleChangesubject_4}
                        placeholder="Enter marks"
                      />
                    </FormGroup>
                  </Col>
                </Row>

                <div className="mt-4">
      <Row>
        <Col md={12}>
          <p
            style={{
              fontWeight: "bold",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "lightgray",
            }}
          >
            B. Strategic Thinking Road Mapping
          </p>
        </Col>
      </Row>

      <Row>
        <Col md={12}>
          <Label for="shortTerm">Short Term</Label>
          {shortTermFields.map((field, index) => (
            <div key={field.id} className="d-flex align-items-center mb-2">
              <Input
                style={{
                  border: "1px solid lightgrey",
                  padding: "6px 10px",
                  borderRadius: "6px",
                  flexGrow: 1,
                  marginRight: "10px",
                }}
                type="textarea"
                id={`shortTerm-${field.id}`}
                name="short_term[]"
                placeholder="Enter Short Term"
                value={field.value}
                onChange={(e) => {
                  const newFields = [...shortTermFields];
                  newFields[index].value = e.target.value;
                  setShortTermFields(newFields);
                }}
              />
              {index > 0 && (
                <Button
                  
                  onClick={() => handleRemoveField(setShortTermFields, shortTermFields, field.id)}
                  style={{
                   
                    backgroundColor: "red",
                    color: "white",
                    border: "none",
                  }}
                >
                  Delete
                </Button>
              )}
            </div>
          ))}
        </Col>
        <Col md={12} className="mt-2 mb-3">
          <Button  style={{
                        
                        
                        backgroundColor: "#080278",
                        color: "white",
                        border: "none",
                      }} onClick={() => handleAddField(setShortTermFields, shortTermFields)}>+</Button>
        </Col>
        <Col md={12}>
          <Label >Long Term</Label>
          {longTermFields.map((field, index) => (
            <div key={field.id} className="d-flex align-items-center mb-2">
              <Input
                style={{
                  border: "1px solid lightgrey",
                  padding: "6px 10px",
                  borderRadius: "6px",
                  flexGrow: 1,
                  marginRight: "10px",
                }}
                type="textarea"
                id={`longTerm-${field.id}`}
                name="long_term[]"
                placeholder="Enter Long Term"
                value={field.value}
                onChange={(e) => {
                  const newFields = [...longTermFields];
                  newFields[index].value = e.target.value;
                  setLongTermFields(newFields);
                }}
              />
              {index > 0 && (
                <Button
                
                  style={{
                   
                    backgroundColor: "red",
                    color: "white",
                    border: "none",
                  }}
                  onClick={() => handleRemoveField(setLongTermFields, longTermFields, field.id)}
                >
                  Delete
                </Button>
              )}
            </div>
          ))}
        </Col>
        <Col md={12} className="mt-2">
          <Button style={{
                   
                   backgroundColor: "#080278",
                   color: "white",
                   border: "none",
                 }} onClick={() => handleAddField(setLongTermFields, longTermFields)}>+</Button>
        </Col>
      </Row>
    </div>

    <div className="mt-4">
      <Row>
        <Col md={12}>
          <p
            style={{
              fontWeight: "bold",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "lightgray",
            }}
          >
            C. EHC SWOT
          </p>
        </Col>
      </Row>

      <Row>
        <Col md={6}>
          <FormGroup>
            <Label for="strength">Strength</Label>
            {strengthFields.map((field, index) => (
              <div key={field.id} className="d-flex align-items-center mb-2">
                <Input
                  style={{
                    border: "1px solid lightgrey",
                    padding: "6px 10px",
                    borderRadius: "6px",
                    flexGrow: 1,
                    marginRight: "10px",
                  }}
                  type="textarea"
                  id={`strength-${field.id}`}
                  name="strength[]"
                  placeholder="Enter Strength"
                  value={field.value}
                  onChange={(e) => {
                    const newFields = [...strengthFields];
                    newFields[index].value = e.target.value;
                    setStrengthFields(newFields);
                  }}
                />
                {index > 0 && (
                  <Button
                  style={{
                        
                        
                    backgroundColor: "red",
                    color: "white",
                    border: "none",
                  }}
                    onClick={() => handleRemoveField(setStrengthFields, strengthFields, field.id)}
                  >
                    Delete
                  </Button>
                )}
              </div>
            ))}
          </FormGroup>
          <Button style={{
                        
                        marginBottom:"15px",
                        backgroundColor: "#080278",
                        color: "white",
                        border: "none",
                      }} onClick={() => handleAddField(setStrengthFields, strengthFields)}>+</Button>
        </Col>

        <Col md={6}>
          <FormGroup>
            <Label>Weakness</Label>
            {weaknessFields.map((field, index) => (
              <div key={field.id} className="d-flex align-items-center mb-2">
                <Input
                  style={{
                    border: "1px solid lightgrey",
                    padding: "6px 10px",
                    borderRadius: "6px",
                    flexGrow: 1,
                    marginRight: "10px",
                  }}
                  type="textarea"
                  id={`weakness-${field.id}`}
                  name="weakness[]"
                  placeholder="Enter Weakness"
                  value={field.value}
                  onChange={(e) => {
                    const newFields = [...weaknessFields];
                    newFields[index].value = e.target.value;
                    setWeaknessFields(newFields);
                  }}
                />
                {index > 0 && (
                  <Button
                  style={{
                        
                        
                    backgroundColor: "red",
                    color: "white",
                    border: "none",
                  }}
                    
                    onClick={() => handleRemoveField1(setWeaknessFields, weaknessFields, field.id)}
                  >
                   Delete
                  </Button>
                )}
              </div>
            ))}
          </FormGroup>
          <Button style={{
                        
                        marginBottom:"15px",
                        backgroundColor: "#080278",
                        color: "white",
                        border: "none",
                      }} onClick={() => handleAddField1(setWeaknessFields, weaknessFields)}>+</Button>
        </Col>
      </Row>

      <Row>
        <Col md={6}>
          <FormGroup>
            <Label for="threats">Threats</Label>
            {threatsFields.map((field, index) => (
              <div key={field.id} className="d-flex align-items-center mb-2">
                <Input
                  style={{
                    border: "1px solid lightgrey",
                    padding: "6px 10px",
                    borderRadius: "6px",
                    flexGrow: 1,
                    marginRight: "10px",
                  }}
                  type="textarea"
                  id={`threats-${field.id}`}
                  name="threats[]"
                  placeholder="Enter Threats"
                  value={field.value}
                  onChange={(e) => {
                    const newFields = [...threatsFields];
                    newFields[index].value = e.target.value;
                    setThreatsFields(newFields);
                  }}
                />
                {index > 0 && (
                  <Button
                  style={{
                        
                        
                    backgroundColor: "red",
                    color: "white",
                    border: "none",
                  }}
                    onClick={() => handleRemoveField1(setThreatsFields, threatsFields, field.id)}
                  >
                   Delete
                  </Button>
                )}
              </div>
            ))}
          </FormGroup>
          <Button style={{
                        
                        marginBottom:"15px",
                        backgroundColor: "#080278",
                        color: "white",
                        border: "none",
                      }} onClick={() => handleAddField1(setThreatsFields, threatsFields)}>+</Button>
        </Col>

        <Col md={6}>
          <FormGroup>
            <Label for="opportunities">Opportunities</Label>
            {opportunitiesFields.map((field, index) => (
              <div key={field.id} className="d-flex align-items-center mb-2">
                <Input
                  style={{
                    border: "1px solid lightgrey",
                    padding: "6px 10px",
                    borderRadius: "6px",
                    flexGrow: 1,
                    marginRight: "10px",
                  }}
                  type="textarea"
                  id={`opportunities-${field.id}`}
                  name="opportunities[]"
                  placeholder="Enter Opportunities"
                  value={field.value}
                  onChange={(e) => {
                    const newFields = [...opportunitiesFields];
                    newFields[index].value = e.target.value;
                    setOpportunitiesFields(newFields);
                  }}
                />
                {index > 0 && (
                  <Button
                  style={{
                        
                        
                    backgroundColor: "red",
                    color: "white",
                    border: "none",
                  }}
                    
                    onClick={() => handleRemoveField(setOpportunitiesFields, opportunitiesFields, field.id)}
                  >Delete
                  </Button>
                )}
              </div>
            ))}
          </FormGroup>
          <Button style={{
                        
                        marginBottom:"15px",
                        backgroundColor: "#080278",
                        color: "white",
                        border: "none",
                      }} onClick={() => handleAddField(setOpportunitiesFields, opportunitiesFields)}>+</Button>
        </Col>
      </Row>
    </div>

                <Row>
                  <Col md={12}>
                    <Button
                      type="submit"
                      style={{
                        float: "right",
                        marginLeft: "5%",
                        backgroundColor: "#080278",
                        color: "white",
                        border: "none",
                      }}
                      // onClick={}
                    >
                      Submit
                    </Button>
                  </Col>
                </Row>
              </CardBody>
              </Form>
            </Card>
          </div>

          <div className="col-12 mt-4">
            <Card className="shadow">
            <Form onSubmit={Addconsultation}>
              <CardHeader className="border-0 d-flex flex-column ">
                <h3 className="mb-0" style={{ color: "black" }}>
                  Consultation (SRC-Strot)
                </h3>
                <Row className="mt-4">
                
                <Col  md={4}>
                <Input type="select" name="ehc_report_id">
                <option>Select ECH Report</option>

          {EchRepotlist?.data?.map((item, index)=>{
            
            return(
              <option value={item?.id} key={index}>{item?.ehc_coordination?.ehc_name}</option>
            )
          })}</Input></Col></Row>
              </CardHeader>
              <CardBody>
                <Row>
                  <Col md={6}>
                    <FormGroup>
                      <Label for="exampleEmail"> Date</Label>
                      <Input
                        style={{
                          border: "1px solid lightgrey",
                          padding: "6px 10px",
                          borderRadius: "6px",
                        }}
                        type="date"
                       
                        name="date"
                        placeholder="Enter Question"
                      />
                    </FormGroup>
                  </Col>
                  <Col md={3}>
                    <FormGroup>
                      <Label for="exampleEmail">Start Time</Label>
                      <Input
                        id="forType"
                        type="select"
                        name="start_time"
                        // onChange={(e) => {
                        //   interViewUser(e.target.value, "board");
                        // }}
                      >
                        <option value="">Select Time</option>
                        <option value="12 Am">12 Am</option>
                        <option value="01 Am">01 Am</option>
                        <option value="02 Am">02 Am</option>
                        <option value="03 Am">03 Am</option>
                        <option value="04 Am">04 Am</option>
                        <option value="05 Am">05 Am</option>
                        <option value="06 Am">06 Am</option>
                        <option value="07 Am">07 Am</option>
                        <option value="08 Am">08 Am</option>
                        <option value="09 Am">09 Am</option>
                        <option value="10 Am">10 Am</option>
                        <option value="11 Am">11 Am</option>
                        <option value="12 Pm">12 Pm</option>
                        <option value="01 Pm">01 Pm</option>
                        <option value="02 Pm">02 Pm</option>
                        <option value="03 Pm">03 Pm</option>
                        <option value="04 Pm">04 Pm</option>
                        <option value="05 Pm">05 Pm</option>
                        <option value="06 Pm">06 Pm</option>
                        <option value="07 pm">07 Pm</option>
                        <option value="08 Pm">08 Pm</option>
                        <option value="09 Pm">09 Pm</option>
                        <option value="10 pm">10 Pm</option>
                        <option value="11 Pm">11 Pm</option>
                      </Input>
                    </FormGroup>
                  </Col>
                  <Col md={3}>
                    <FormGroup>
                      <Label for="exampleEmail">End Time</Label>
                      <Input
                        id="forType"
                        type="select"
                        name="end_time"
                        // onChange={(e) => {
                        //   interViewUser(e.target.value, "board");
                        // }}
                      >
                         <option value="">Select Time</option>
                        <option value="12 Am">12 Am</option>
                        <option value="01 Am">01 Am</option>
                        <option value="02 Am">02 Am</option>
                        <option value="03 Am">03 Am</option>
                        <option value="04 Am">04 Am</option>
                        <option value="05 Am">05 Am</option>
                        <option value="06 Am">06 Am</option>
                        <option value="07 Am">07 Am</option>
                        <option value="08 Am">08 Am</option>
                        <option value="09 Am">09 Am</option>
                        <option value="10 Am">10 Am</option>
                        <option value="11 Am">11 Am</option>
                        <option value="12 Pm">12 Pm</option>
                        <option value="01 Pm">01 Pm</option>
                        <option value="02 Pm">02 Pm</option>
                        <option value="03 Pm">03 Pm</option>
                        <option value="04 Pm">04 Pm</option>
                        <option value="05 Pm">05 Pm</option>
                        <option value="06 Pm">06 Pm</option>
                        <option value="07 pm">07 Pm</option>
                        <option value="08 Pm">08 Pm</option>
                        <option value="09 Pm">09 Pm</option>
                        <option value="10 pm">10 Pm</option>
                        <option value="11 Pm">11 Pm</option>
                      </Input>
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col md={6}>
                    <FormGroup>
                      <Label for="exampleEmail">Consultation Status</Label>
                      <Input  name="status" type="select">
                        <option value="">
                          Select Consultation Status
                        </option>
                        <option value="connected">Connected </option>
                        <option value="not connected">Not connected </option>
                        <option value="not responding">Not Responding </option>
                      </Input>
                    </FormGroup>
                  </Col>
                  <Col md={6}>
                    <FormGroup>
                      <Label>Meeting Link</Label>
                      <Input
                        style={{
                          border: "1px solid lightgrey",
                          padding: "6px 10px",
                          borderRadius: "6px",
                        }}
                        type="text"
                       
                        name="meeting_link"
                        placeholder="Enter Meeting Link"
                      />
                    </FormGroup>
                  </Col>
                </Row>

                <Row>
                  <Col md={12}>
                    <Button
                      type="submit"
                      style={{
                        float: "right",
                        marginLeft: "5%",
                        backgroundColor: "#080278",
                        color: "white",
                        border: "none",
                      }}
                      // onClick={}
                    >
                      Schedule
                    </Button>
                  </Col>
                </Row>
              </CardBody>
              </Form>
            </Card>
          </div>
        </Row>

        <Modal isOpen={modal1} toggle={toggleModal}>
          <ModalHeader toggle={toggleModal}>
            <h4> Assign Tutors</h4>
          </ModalHeader>
          <ModalBody>
            <Row>
              <Col md={12}>
                <FormGroup>
                  <Label for="citySelect">Select Tutor</Label>
                  <Select
                    id="citySelect"
                    // name="citySelect"
                    // value={{
                    //   label: selectedCity,
                    //   value: selectedCity,
                    // }}
                    // onChange={handleCityChange}
                    // options={citiesOfSelectedState}
                    placeholder="Select Tutor"
                    isSearchable={true} // Enable searching within dropdown
                  />
                </FormGroup>
              </Col>
            </Row>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginTop: "20px",
              }}
            >
              <Button color="secondary" onClick={toggleModal}>
                Cancel
              </Button>
              {/* 
                      {addsLoadig ? (
                        <Loader color={"blue"} />
                      ) : ( */}
              <Button
                type="submit"
                style={{
                  float: "right",
                  marginLeft: "5%",
                  backgroundColor: "#080278",
                  color: "white",
                  border: "none",
                }}
                // onClick={}
              >
                Link Tutor
              </Button>
            </div>
          </ModalBody>
        </Modal>
{/*  add discover model*/}
        <Modal isOpen={modal2} toggle={toggleModal1}>
          <ModalHeader toggle={toggleModal1}>
            <h4>Discovery Call Add</h4>
          </ModalHeader>
          <ModalBody>
            <Form onSubmit={Adddiscovery}>
            <Row className="mt-3">
              <Col md={6}>
                <FormGroup>
                  <Label>Call Done By</Label>
                  <Input  name="call_done_by" type="select">
                    <option value="">Select Call Done By </option>
                    {supervisorlistdata?.data?.map((item, index)=>{
                      console.log("ggggggggg----",item)
                      return(
                        <option value={item?.user_id}>{item?.auth_user?.first_name} {" "} {item?.auth_user?.last_name}</option>

                      )
                    })}
                  </Input>
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label >Status</Label>
                  <Input  name="status" type="select">
                    <option value="">Select Status</option>
                    <option value="Done">Done </option>
                    <option value="Not Done">Not Done </option>
                    
                  </Input>
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <Label>Date</Label>
                <Input type="date" name="date"/>
              </Col>

              <Col md={6}>
                {" "}
                <Label>Time</Label>
                <Input
                name="time"
                
                  type="select"
                  // onChange={(e) => {
                  //   interViewUser(e.target.value, "board");
                  // }}
                >
                  <option value="">select Option</option>
                  <option value="12AM - 02AM">12AM - 02AM</option>
                  <option value="02AM - 04AM">02AM - 04AM</option>
                  <option value="04AM - 06AM">04AM - 06AM</option>
                  <option value="06AM - 08AM">06AM - 08AM</option>
                  <option value="08AM - 10AM">08AM - 10AM</option>
                  <option value="10AM - 12PM">10AM - 12PM</option>
                  <option value="12PM - 02PM">12PM - 02PM</option>
                  <option value="02PM - 04PM">02PM - 04PM</option>
                  <option value="04PM - 06PM">04PM - 06PM</option>
                  <option value="06PM - 08PM">06PM - 08PM</option>
                  <option value="08PM - 10PM">08PM - 10PM</option>
                </Input>
              </Col>
            </Row>

            <Row className="mt-3">
              <Col md={12}>
                <FormGroup>
                  <Label>Comment/Feedback</Label>
                  <Input
                    style={{
                      border: "1px solid lightgrey",
                      padding: "6px 10px",
                      borderRadius: "6px",
                    }}
                    type="textarea"
                    id="name"
                    name="comment"
                    placeholder="Enter Comment/Feedback"
                  />
                </FormGroup>
              </Col>
            </Row>

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginTop: "20px",
              }}
            >
              <Button color="secondary" onClick={toggleModal1}>
                Cancel
              </Button>
              {/* 
                      {addsLoadig ? (
                        <Loader color={"blue"} />
                      ) : ( */}
              <Button
                color="primary"
                type="submit"
                style={{ float: "right", marginLeft: "5%" }}
                // onClick={}
              >
                Save
              </Button>
            </div>
            </Form>
          </ModalBody>
        </Modal>
{/* EHC Coordination model */}
        <Modal isOpen={modal3} toggle={toggleModal2}>
          <ModalHeader toggle={toggleModal2}>
            <h4> EHC Coordination Added</h4>
           
          </ModalHeader>
          <ModalBody>
            <Form onSubmit={AddCordination} >
              <Row>
                <Col md={12}>
                <FormGroup>
                  <Label> Ech Name</Label>
                  <Input  name="ehc_name" type="text"/>
                </FormGroup>
                </Col>
              </Row>
            <Row>
              <Col md={12}>
                <FormGroup>
                  <Label> Supervisor</Label>
                  <Input  name="supervisor_id" type="select">
                    <option value="">Select Supervisor </option>
                    {supervisorlistdata?.data?.map((item, index)=>{
                      
                      return(
                        <option value={item?.user_id}>{item?.auth_user?.first_name} {" "} {item?.auth_user?.last_name}</option>

                      )
                    })}
                  </Input>
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <Label >Date</Label>
                <Input name="date" type="date" />
              </Col>

              <Col md={6}>
                {" "}
                <Label >Time</Label>
                <Input
                name="time"
                  
                  type="select"
                  // onChange={(e) => {
                  //   interViewUser(e.target.value, "board");
                  // }}
                >
                  <option value="">select Option</option>
                  <option value="12AM - 02AM">12AM - 02AM</option>
                  <option value="02AM - 04AM">02AM - 04AM</option>
                  <option value="04AM - 06AM">04AM - 06AM</option>
                  <option value="06AM - 08AM">06AM - 08AM</option>
                  <option value="08AM - 10AM">08AM - 10AM</option>
                  <option value="10AM - 12PM">10AM - 12PM</option>
                  <option value="12PM - 02PM">12PM - 02PM</option>
                  <option value="02PM - 04PM">02PM - 04PM</option>
                  <option value="04PM - 06PM">04PM - 06PM</option>
                  <option value="06PM - 08PM">06PM - 08PM</option>
                  <option value="08PM - 10PM">08PM - 10PM</option>
                </Input>
              </Col>
            </Row>

            <Row className="mt-3">
              <Col md={12}>
                <FormGroup>
                  <Label >Comment/Feedback</Label>
                  <Input
                    style={{
                      border: "1px solid lightgrey",
                      padding: "6px 10px",
                      borderRadius: "6px",
                    }}
                    type="textarea"
                 
                    name="comment"
                    placeholder="Enter Comment/Feedback"
                  />
                </FormGroup>
              </Col>
            </Row>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginTop: "20px",
              }}
            >
              <Button color="secondary" onClick={toggleModal2}>
                Cancel
              </Button>

              <Button
                color="primary"
                type="submit"
                style={{ float: "right", marginLeft: "5%" }}
                // onClick={}
              >
                Save
              </Button>
            </div></Form>
          </ModalBody>
        </Modal>

        <Modal isOpen={modal4} toggle={toggleModal4} size="lg">
          <ModalHeader toggle={toggleModal4}>
            <h4> Edit Parent Details</h4>
          </ModalHeader>
          <ModalBody>
            <Form onSubmit={handleSubmiteditParentDetails}>
              <Row>
                <Col md={6}>
                  <FormGroup>
                    <Label for="exampleEmail">Parent First Name </Label>
                    <Input
                      type="text"
                      placeholder="Enter Name"
                      name="first_name"
                      defaultValue={`${parentdata?.user?.first_name}` }
                    />
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <Label for="exampleEmail">Parent Last Name</Label>
                    <Input
                      type="text"
                      placeholder="Enter Last Name"
                      name="last_name"
                      defaultValue={parentdata?.user?.last_name}
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col md={6}>
                  <FormGroup>
                    <Label for="exampleEmail">Email Address</Label>
                    <Input
                      type="text"
                      placeholder="Enter Email Address"
                      name="email"
                      defaultValue={parentdata?.user?.email}
                    />
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <Label for="exampleEmail">Mobile no</Label>
                    <Input
                    name="mobile"
                      type="text"
                      placeholder="Enter Mobile no"
                      readOnly
                      defaultValue={parentdata?.mobile}
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col md={6}>
                  <FormGroup>
                    <Label for="exampleEmail">Gender</Label>
                    <Input
                     
                      type="select"
                      name="gender"
                      defaultValue={parentdata?.gender}
                     // onChange={(e) => {
                        //setGender(e.target.value);}}
                    >
                      <option value="Male">Male</option>
                      <option value="Female">Female</option>
                      <option value="Other">Other</option>
                    </Input>
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <Label for="exampleEmail">Mode of Tuition</Label>

                    <Input
                      id="forType"
                      name="modeOfTution"
                      type="select"
                      defaultValue={parentdata?.modeOfTution
                        || "not filled"}
                      //onChange={(e) => {
                       // setMode(e.target.value);}}
                    ><option value="">select</option>
                      <option value="Online">Online</option>
                      <option value="Offline">Offline</option>
                    </Input>
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col md={6}>
                  <FormGroup>
                    <Label for="exampleEmail">State</Label>
                    <Input
                      id="forstate"
                      name="state"
                      type="select"
                      defaultValue={parentdata?.state}
                      onChange={handleStateChange}
                     
                    >
                      
                      {state?.map((item, key) => {
                        return (
                          <option key={key}
                            value={item?.name}
                          >
                            {item?.name}
                          </option>
                        );
                      })}
                    </Input>
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <Label for="exampleEmail">Loction</Label>
                    <Input
                      type="text"
                      placeholder="Enter Loaction"
                      name="location"
                      defaultValue={parentdata?.location || "not filled"}
                    />
                  </FormGroup>
                </Col>
              </Row>

              <Row>
                <Col md={6}>
                  <FormGroup>
                    <Label for="exampleEmail">City</Label>
                    {!city && 
                     <Input
                    readOnly
                     name="city"
                     type="text"
                     defaultValue={parentdata?.city || "not filled"}
                   >
                    
                     
                    
                    
                    
                    
                   </Input>}
                   {city && 
                    <Input
                    
                      name="city"
                      type="select"
                      defaultValue={dataList?.data?.city || "not filled"}
                    >
                     
                      {city?.map((item, index)=>{
                        return(
                          <option value={item.name.toLowerCase()}>{item?.name.toLowerCase()}</option>)
                      })}
                     
                     
                    </Input>}
                  </FormGroup>
                </Col>
              </Row>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginTop: "20px",
                }}
              >
                <Button color="secondary" onClick={toggleModal4}>
                  Cancel
                </Button>
                {/* 
                      {addsLoadig ? (
                        <Loader color={"blue"} />
                      ) : ( */}
                <Button
                  color="primary"
                  type="submit"
                  style={{
                    float: "right",
                    marginLeft: "5%",
                    backgroundColor: "#080278",
                    color: "white",
                  }}

                  // onClick={}
                >
                  Save
                </Button>
              </div>
            </Form>
          </ModalBody>
        </Modal>
        <Modal isOpen={modal5} toggle={toggleModal5}>
          <ModalHeader toggle={toggleModal5}>
            <h4> Create Package</h4>
          </ModalHeader>
          <ModalBody>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginTop: "20px",
              }}
            >
              <Button color="secondary" onClick={toggleModal5}>
                Cancel
              </Button>
              {/* 
                      {addsLoadig ? (
                        <Loader color={"blue"} />
                      ) : ( */}
              <Button
                color="primary"
                type="submit"
                style={{ float: "right", marginLeft: "5%" }}
                // onClick={}
              >
                Save
              </Button>
            </div>
          </ModalBody>
        </Modal>
      </Container>
    </>
  );
};

export default ViewEHC;
